export default __webpack_public_path__ + "static/media/transpac-fundo.121723da.png";